import axios from '@/libs/axios'
import { handleCatch } from '@/utils'
import { ApiCode } from '@/const/api'

export default {
  async getStudentCertificate(params) {
    try {
      const response = await axios.get('uni/studentCertificates', { params })
      const { data } = response
      return data.data
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
  // eslint-disable-next-line consistent-return
  async downloadDocument(params) {
    try {
      const response = await axios.get('uni/studentCertificateFiles/download', { params })
      const { data } = response
      if (data.code === ApiCode.SUCCESS) {
        return data.data
      }
    } catch (e) {
      handleCatch(e)
    }
  },
  async updateData( params) {
    try {
      const response = await axios.put('uni/studentCertificates', params)
      const { data } = response
      return {
        isSuccessful: data.code === ApiCode.SUCCESS,
        message: data.message,
      }
    } catch (e) {
      handleCatch(e)
    }
    return null
  },
}
